// CLARTEXT SPRACHE – Kroatisch (hr). Vollständige Übersetzung aller Keys
// (1:1-Key-Menge wie de.js/en.js, von Anfang an ohne Lücken — Juni 2026).
// Weltinhalte (Titel, Fragen, GBU-/BA-Texte) sind hier bewusst NICHT enthalten;
// sie kommen aus dem serverseitigen Translation-Worker.
const hr = {
  // Gemeinsame
  "common.loading": "Učitavanje…",

  // PIN-Login (/monteur/login)
  "login.eyebrow": "Prijava",
  "login.title": "Tvoj PIN",
  "login.subtitle": "Kod tvrtke + 4-znamenkasti PIN od tvog šefa.",
  "login.companyCodeLabel": "Kod tvrtke",
  "login.companyCodePlaceholder": "npr. LUMPE",
  "login.submitting": "Prijava u tijeku…",
  "login.backAria": "Natrag na prijavu",
  "login.errorNoCode": "Najprije unesi kod tvrtke.",
  "login.errorUnknown": "Tvrtka ili PIN nepoznati.",

  // Aufgabenliste (/monteur)
  "tasks.companyFallback": "Vaša tvrtka",
  "tasks.portalSubtitle": "Portal za osposobljavanja",
  "tasks.loggedInAs": "Prijavljen kao",
  "tasks.heading": "Tvoji zadaci",
  "tasks.openCount": "{count} otvoreno",
  "tasks.emptyToday": "Danas nema otvorenih zadataka.",
  "tasks.newBanner": "Imaš {count} novih osposobljavanja od zadnjeg posjeta.",
  "tasks.newBadge": "Novo",
  "tasks.newBannerDismissAria": "Zatvori obavijest",
  "tasks.backAria": "Natrag na pregled",
  "home.tasksTitle": "Osposobljavanja",
  "home.searchTitle": "Priručnik",
  "home.searchSubtitle": "Brzo pronađi sigurnosne informacije",
  "home.hspTitle": "Plan zaštite kože",
  "home.hspSubtitle": "Zaštita kože i odabir rukavica na jednom mjestu",
  "home.driverTitle": "Provjera vozačke dozvole",
  "home.driverOpen": "Molimo predaj vozačku dozvolu",
  "home.driverSubmitted": "Čeka provjeru od strane tvrtke",
  "home.driverUpToDate": "Trenutno važeća",
  "home.settingsTitle": "Postavke",
  "home.settingsSubtitle": "Upravljanje e-poštom i jezikom",
  "home.comingSoon": "Uskoro dostupno",
  "home.newBubbleAria": "{count} novih osposobljavanja",
  "settings.profileTitle": "Profil",
  "settings.profileHint": "Ime i tvrtku održava vaša tvrtka.",
  "settings.emailTitle": "E-pošta za obavijesti",
  "settings.emailPurpose": "Koristi se isključivo za obavještavanje o novim osposobljavanjima.",
  "settings.emailPlaceholder": "ime@primjer.hr",
  "settings.emailSave": "Spremi",
  "settings.emailSaved": "Spremljeno",
  "settings.emailInvalid": "Unesi valjanu adresu e-pošte.",
  "settings.emailRemoveHint": "Isprazni polje i spremi kako bi se odjavio od obavijesti.",
  "settings.saveError": "Spremanje nije uspjelo. Pokušaj ponovno.",
  "settings.privacyLink": "Izjava o zaštiti podataka",
  "settings.consentLabel": "Želim primati obavijesti o novim osposobljavanjima putem e-pošte.",
  "settings.languageTitle": "Jezik",
  "settings.langNotBooked": "Zasivljene jezike vaša tvrtka još nije rezervirala. Obratite se svom šefu ako želite koristiti neki od njih.",
  "tasks.quickLookup": "Brzo pretraživanje",
  "tasks.doneHeading": "Već obavljeno",
  "tasks.dueLabel": "Rok",
  "tasks.doneAtLabel": "Obavljeno dana",
  "tasks.logoutAria": "Odjava",

  // Aushangpflicht-Anzeige (Mitarbeiter-Link + Seite)
  "aushang.linkTitle": "Zakoni i propisi koji se obvezno objavljuju",
  "aushang.linkSubtitle": "Pregledaj službene izvorne tekstove",
  "aushang.pageTitle": "Zakoni i propisi koji se obvezno objavljuju",
  "aushang.categoryAllgemein": "Opće zakonske osnove",
  "aushang.categoryDguv": "DGUV propisi i tehnička pravila",

  // Aufgabendetail (/monteur/aufgabe/:id)
  "aufgabe.notFound": "Zadatak nije pronađen.",
  "aufgabe.wrongOne": "Jedan odgovor nije bio točan. Odgovori ponovno.",
  "aufgabe.wrongMany":
    "{count} odgovora nije bilo točno. Odgovori ponovno.",
  "aufgabe.saveFailed": "Spremanje nije uspjelo. Pokušaj ponovno.",
  "aufgabe.doneTitle": "Uspjeh!",
  "aufgabe.doneBody":
    "Osposobljavanje „{title}“ je završeno. Tvoja potvrda je automatski izrađena i nalazi se u revizijskoj mapi tvoje tvrtke.",
  "aufgabe.backToTasks": "Natrag na moje zadatke",
  "aufgabe.stepContent": "Sadržaj",
  "aufgabe.stepQuestion": "Pitanje {current} od {total}",
  "aufgabe.backShort": "Zadaci",
  "aufgabe.readCalm": "Pročitaj jednom u miru.",
  "aufgabe.questionsFollow": "Zatim slijedi {count} kratkih pitanja za razumijevanje.",
  "aufgabe.questionLabel": "Pitanje za razumijevanje {current} / {total}",
  "aufgabe.wrongAgain":
    "Ovaj odgovor nije bio točan u zadnjem pokušaju. Odaberi ponovno.",
  "aufgabe.prev": "Natrag",
  "aufgabe.saving": "Spremanje…",
  "aufgabe.finish": "Završi osposobljavanje",
  "aufgabe.toQuestions": "Na pitanja",
  "aufgabe.next": "Dalje",

  // Nachschlage-Suche (Komponente MonteurWeltSuche)
  "suche.placeholder": "Pretraži – npr. „akumulator“, „naočale“, „ljestve“…",
  "suche.inputAria": "Pretraži dokumentacijski svijet",
  "suche.matchIn": "Rezultati u {label}:",
  "suche.empty": "Nije pronađen odgovarajući dokumentacijski svijet.",
  "suche.emptyHint": "Pokušaj drugu riječ, npr. „OZO“ ili „zavoj“.",

  // Welt-Nachschlagewerk (/monteur/welt/:id) – NUR UI-Rahmen/Labels.
  "welt.headerTitle": "Priručnik",
  "welt.backAria": "Natrag",
  "welt.errorNotAvailable": "Ovaj dokumentacijski svijet trenutno nije dostupan.",
  "welt.errorLoad": "Svijet nije bilo moguće učitati.",
  "welt.backToTasks": "Natrag na moje zadatke",
  "welt.loading": "Učitavanje svijeta…",
  "welt.doctype": "Priručnik",
  "welt.versionLabel": "Verzija",
  "welt.gbuTitle": "Procjena rizika",
  "welt.noHazards": "Nema dokumentiranih pojedinačnih opasnosti.",
  "welt.residualRisk": "Preostali rizik:",
  "welt.measureTechnical": "Tehničke",
  "welt.measureOrganizational": "Organizacijske",
  "welt.measurePersonal": "Osobne",
  "welt.responsible": "Odgovoran:",
  "welt.baTitle": "Radna uputa",
  "welt.baSubtitle": "Prema TRBS / GefStoffV / BetrSichV",
  "welt.mainHazards": "Glavne opasnosti",
  "welt.protectiveMeasures": "Zaštitne mjere i pravila ponašanja",
  "welt.emergency": "U slučaju nužde",
  "welt.firstAid": "Prva pomoć",
  "welt.disposalHazmat": "Skladištenje i zbrinjavanje",
  "welt.disposalVehicle": "Parkiranje",
  "welt.disposalDefault": "Stavljanje izvan pogona",
  "welt.instructionTitle": "Osposobljavanje",
  "welt.instructionSubtitle": "Prema DGUV V1 §4",
  "welt.visualTitle": "Vizualna pomagala za učenje",
  "welt.visualSubtitle":
    "Podupiru razumijevanje – ne mijenjaju sadržaje, potvrde ni PDF-ove",
  "welt.questionsTitle": "Pitanja za razumijevanje",
  "welt.questionsSubtitle":
    "{count} pitanja — samoprovjera, bez označavanja točnog odgovora",
  "welt.maintenanceTitle": "Upute za ispitivanje i održavanje",
  "welt.maintenanceSubtitle": "Prema BetrSichV / UVV",
  "welt.performedBy": "Izvođenje:",
  "welt.recommendedCheck": "Preporučena stručna provjera:",
  "welt.recurrenceTitle": "Ciklusi ponavljanja",
  "welt.recurrenceSubtitle": "Po modulu – sustav automatski nadzire",
  "welt.recurrenceUnterweisung": "Osposobljavanje",
  "welt.recurrenceGbuReview": "Procjena rizika – pregled",
  "welt.recurrenceWartung": "Održavanje / ispitivanje",
  "welt.recurrence.none": "–",
  "welt.recurrence.einmalig": "Jednokratno",
  "welt.recurrence.monatlich": "Mjesečno",
  "welt.recurrence.vierteljaehrlich": "Tromjesečno",
  "welt.recurrence.halbjaehrlich": "Polugodišnje",
  "welt.recurrence.jaehrlich": "Godišnje",
  "welt.recurrence.zwei_jahre": "Svake 2 godine",

  // Aufgaben-Status (StatusBadge)
  "status.offen": "Otvoreno",
  "status.erledigt": "Obavljeno",
  "status.ueberfaellig": "Prekoračeno",

  // Feste Abschnitts-Überschriften der Unterweisungs-Inhalte (Anzeige-Lookup)
  "contentHeading.Worum geht es?": "O čemu se radi?",
  "contentHeading.Welche Gefahren bestehen?": "Koje opasnosti postoje?",
  "contentHeading.Vor Arbeitsbeginn beachten": "Pripaziti prije početka rada",
  "contentHeading.Während der Arbeit beachten": "Pripaziti tijekom rada",
  "contentHeading.Nach der Arbeit beachten": "Pripaziti nakon rada",

  // VLO-Präsentationslabels
  "vlo.safetySymbols.title": "Sigurnosni simboli",
  "vlo.safetySymbols.hint":
    "Ovi simboli podupiru osposobljavanje. Mjerodavan je uvijek tekst.",
  "vlo.psaSummary.title": "Sažetak OZO",
  "vlo.hazardMarkers.title": "Oznake opasnosti",
  "vlo.learningFocus.title": "Fokus učenja",
  "vlo.richtigFalsch.title": "Ispravno i pogrešno",
  "vlo.richtigFalsch.correct": "Ispravno",
  "vlo.richtigFalsch.wrong": "Pogrešno",

  // Druck-/Plakat-Labels
  "plakat.eyebrow": "Plakat osposobljavanja",
  "plakat.subtitle": "Siguran rad – najvažnija pravila na prvi pogled",
  "plakat.symbols": "Sigurnosni znakovi",
  "plakat.hazards": "Opasnosti",
  "plakat.richtigFalsch": "Ispravno i pogrešno",
  "plakat.correct": "Ispravno",
  "plakat.wrong": "Pogrešno",
  "plakat.psa": "Osobna zaštitna oprema (OZO)",
  "plakat.rules": "Najvažnija pravila",
  "plakat.qrTitle": "Otvori svijet izravno",
  "plakat.qrText": "Skeniraj QR kod mobitelom, unesi PIN – dokumentacijski svijet odmah se otvara.",
  "plakat.footerHint": "Ovaj plakat podupire osposobljavanje. Mjerodavno je i dalje potpuno osposobljavanje.",
  "plakat.moreInFull": "Daljnji sadržaji u potpunom osposobljavanju",

  // Gruppen-Unterüberschriften + Mehrseitigkeit
  "plakat.hazardsSub": "Što se može dogoditi?",
  "plakat.correctSub": "Ovako se radi sigurno.",
  "plakat.wrongSub": "Ovako se ne smije raditi.",
  "plakat.continued": "Nastavak",
  "plakat.page": "Stranica",

  // Gemeinsame UI-Chrome-Texte
  "common.back": "Natrag",
  "common.notEnabled": "Ovaj prikaz nije aktiviran za vašu tvrtku.",

  // Aushang-Bedienoberfläche (Gesetzestexte selbst bleiben amtlich deutsch)
  "aushang.kicker": "Obveza objave",
  "aushang.intro": "Poveznice na službene izvorne tekstove. Operater centralno održava popis; ažuriranja se provjeravaju prije preuzimanja.",
  "aushang.loadError": "Objavu nije bilo moguće učitati.",
  "aushang.listLoading": "Učitavanje objave…",
  "aushang.listEmpty": "Trenutno nema unosa — operater održava popis putem operaterske konzole.",
  "aushang.categoryEmpty": "Nema unosa u ovoj kategoriji.",

  // Hautschutzplan-Ansicht (das Plakat selbst bleibt deutsch)
  "hsp.kicker": "Plan zaštite ruku",
  "hsp.titleFallback": "Plan zaštite kože i ruku",
  "hsp.loadError": "Plan zaštite ruku nije bilo moguće učitati.",
  "hsp.empty": "Za ovo područje rada trenutno ne postoji plan zaštite ruku.",
  "hsp.plakatCreatingTitle": "Plakat se izrađuje",
  "hsp.plakatCreatingText": "Pri prvom otvaranju izrađuju se slike — to može potrajati do dvije minute. Nakon toga plakat je odmah dostupan.",
  "hsp.plakatFailedTitle": "Plakat nije bilo moguće izraditi.",
  "hsp.plakatFailedHint": "Pokušajte ponovno. Tekstualni prikaz dostupan je u nastavku.",
  "hsp.plakatReload": "Plakat trenutno nije bilo moguće učitati. Ponovno učitajte stranicu.",
  "hsp.plakatTimeout": "Izrada traje dulje od očekivanog. Pokušajte kasnije ponovno.",
  "hsp.plakatRetry": "Plakat nije bilo moguće izraditi. Pokušajte ponovno.",
  "hsp.plakatLoadFailed": "Plakat trenutno nije bilo moguće učitati.",
  "hsp.plakatImgError": "Sliku plakata nije bilo moguće prikazati.",
  "hsp.plakatAlt": "Plakat plana zaštite ruku",
  "hsp.plakatLoadingAria": "Plakat se učitava",
  "hsp.textOpen": "Prikaži kao tekst",
  "hsp.textClose": "Zatvori tekstualni prikaz",
  "hsp.thWas": "Što",
  "hsp.thWann": "Kada",
  "hsp.thWomit": "Čime",
  "hsp.thWie": "Kako",
  "hsp.firstAidTitle": "Prva pomoć kod kontakta s kožom",
  "hsp.gsvOne": "1 opasna tvar u ovom području",
  "hsp.gsvMany": "{count} opasnih tvari u ovom području",
  "hsp.gsvMenge": "Količina u tvrtki:",
  "hsp.gsvHSaetze": "H-oznake:",
  "hsp.psaHandschutz": "Zaštita ruku",
  "hsp.psaAtemschutz": "Zaštita dišnih organa",
  "hsp.psaAugenschutz": "Zaštita očiju",
  "hsp.psaKoerperschutz": "Zaštita tijela",
  "hsp.psaErsteHilfe": "Prva pomoć nakon kontakta s kožom",
  "hsp.psaAetzReiz": "Nagrizajuće/nadražujuće djelovanje",
  "hsp.psaSensibilisierung": "Senzibilizacija",
  "hsp.psaPSaetze": "P-oznake",

  // Führerscheinkontrolle (Mitarbeiter)
  "fuehrerschein.title": "Provjera vozačke dozvole",
  "fuehrerschein.loadError": "Zadatak nije bilo moguće učitati.",
  "fuehrerschein.notApplicable": "Za vas trenutno nije predviđena provjera vozačke dozvole.",
  "fuehrerschein.categoriesTitle": "Vaše vrste vozila",
  "fuehrerschein.categoriesSubtitle": "Ove je vrste vozila vaš poslodavac odredio za vas.",
  "fuehrerschein.categoriesEmpty": "Nema dodijeljenih kategorija.",
  "fuehrerschein.upToDateTitle": "Vozačka dozvola trenutno važeća",
  "fuehrerschein.upToDateText": "Trenutno nema predstojeće provjere.",
  "fuehrerschein.nextDue": "Sljedeća provjera dospijeva",
  "fuehrerschein.lastDecision": "Zadnje odobrenje:",
  "fuehrerschein.submittedTitle": "Predaja uspješna",
  "fuehrerschein.submittedText": "Fotografija vaše vozačke dozvole i izjava sada su kod poslodavca na provjeri.",
  "fuehrerschein.submittedAt": "Predano dana",
  "fuehrerschein.declarationTitle": "Izjava",
  "fuehrerschein.declarationAccept": "Pročitao/la sam izjavu i potvrđujem je.",
  "fuehrerschein.photoFrontTitle": "Fotografija vozačke dozvole: prednja strana",
  "fuehrerschein.photoFrontHint": "Fotografirajte prednju stranu svoje vozačke dozvole dobro čitljivo (ime i datum isteka vidljivi).",
  "fuehrerschein.photoBackTitle": "Fotografija vozačke dozvole: stražnja strana",
  "fuehrerschein.photoBackHint": "Fotografirajte stražnju stranu svoje vozačke dozvole dobro čitljivo (tablica kategorija vidljiva).",
  "fuehrerschein.previewFrontAlt": "Pregled vozačke dozvole – prednja strana",
  "fuehrerschein.previewBackAlt": "Pregled vozačke dozvole – stražnja strana",
  "fuehrerschein.otherPhoto": "Druga fotografija",
  "fuehrerschein.remove": "Ukloni",
  "fuehrerschein.pickFront": "Snimi prednju stranu ili odaberi datoteku",
  "fuehrerschein.pickBack": "Snimi stražnju stranu ili odaberi datoteku",
  "fuehrerschein.pickLimits": "Maks. 12 MB · JPEG, PNG, WEBP, HEIC",
  "fuehrerschein.submit": "Predaj",
  "fuehrerschein.submitting": "Predaja…",
  "fuehrerschein.submitSuccess": "Predaja uspješna.",
  "fuehrerschein.submitFailed": "Predaja nije uspjela. Pokušajte ponovno.",
  "fuehrerschein.errFormat": "Nepodržani format slike. Odaberite JPEG, PNG, WEBP, HEIC ili HEIF.",
  "fuehrerschein.errSize": "Datoteka prevelika. Maksimum: 12 MB.",
  "fuehrerschein.ocrPreparing": "Automatska pomoć pri čitanju priprema se…",
  "fuehrerschein.ocrUnavailable": "OCR privremeno nedostupan — vozačku dozvolu provjerite ručno.",
  "fuehrerschein.ocrBannerStrong": "Automatski prijepis",
  "fuehrerschein.ocrBannerRest": " — nije provjera od strane CLartext-a, ne zamjenjuje vizualnu provjeru.",
  "fuehrerschein.ocrName": "Ime (očitano)",
  "fuehrerschein.ocrExpiry": "Datum isteka (očitano)",
  "fuehrerschein.ocrClasses": "Kategorije (očitano)",
};

export default hr;
